import "./ConfigurationGroupCareEdit.html";
import "./ConfigurationGroupCareEdit.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import ConfigurationGroupCareEditComponentController from "./ConfigurationGroupCareEditComponentController";

export default class ConfigurationGroupCareEditComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = ConfigurationGroupCareEditComponentController;
        this.templateUrl = "/App/Components/Site/ConfigurationGroups/Care/Edit/ConfigurationGroupCareEdit.html";
    }
}

module("mmManagePortal").component("mmConfigurationGroupCareEdit", new ConfigurationGroupCareEditComponent());
